import { useEffect, useState } from 'react';
import type { Session } from '@supabase/supabase-js';
import { alCambiarSesion, sesionActual } from '../services/auth.js';

/** `undefined` mientras se comprueba; `null` sin sesión; la sesión si hay una (CUENTAS-01). */
export function useSesion(): Session | null | undefined {
  const [sesion, setSesion] = useState<Session | null | undefined>(undefined);

  useEffect(() => {
    void sesionActual().then(setSesion);
    return alCambiarSesion(setSesion);
  }, []);

  return sesion;
}
